import { Node, mergeAttributes } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import FlexRow from "./FlexRow.vue";

export default Node.create({
  name: "flexrow",

  group: "block",
  content: "flexcolumn*",
  atom: true,
  isolating: true,

  addAttributes() {
    return {
      class: "aunfrow row"
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[class*=row]"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0
    ];
  },

  addNodeView() {
    return VueNodeViewRenderer(FlexRow);
  }
});
